import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

const MyPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '#E7EEFF',
          100: '#C7DFFF',
          200: '#A1C7FF',
          300: '#7EADFF',
          400: '#5F92FF',
          500: '#3B82F6',
          600: '#2A6FD9',
          700: '#1D5DC0',
          800: '#134D9E',
          900: '#0A3B83',
        },
        success: { 500: '#10B981' },
        warning: { 500: '#F59E0B' },
        danger: { 500: '#EF4444' },
      },
      dark: {
        primary: {
          50: '#BFCCFF',
          100: '#94B4FF',
          200: '#6A92FF',
          300: '#4070FF',
          400: '#2A5DFF',
          500: '#3B82F6',
          600: '#2E6ED9',
          700: '#235CC0',
          800: '#194B9E',
          900: '#103983',
        },
      },
    },
  },
  components: {
    button: {
      root: {
        borderRadius: '6px',
        raisedShadow: '0 0 0 0.2rem rgba(59, 130, 246, 0.3)',
      },
    },
  },
});

export { MyPreset };
